import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useParams } from "react-router-dom";
import PartnersCarousel from "../../reusable/PartnersCarousel";
import RandomTestimonial from "../../reusable/RandomTestimonial";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import LatestInsights from "../../reusable/LatestInsights";
import Accreditations from "../../reusable/fieldGroups/Accreditations";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import ConsultancyBullets from "../../reusable/fieldGroups/ConsultancyBullets";
import ConsultancyTabs from "../../reusable/fieldGroups/ConsultancyTabs";
import Specialists from "../../reusable/fieldGroups/Specialists";
import ConsultingMenu from "./ConsultingMenu";
import ConsultancyModules from "../../reusable/ConsultancyModules";

export default function SingleConsultancy({ page, isInitialLoading }) {
  const { slug } = useParams();

  const [consultancy, setConsultancy] = useState();

  //Fetch single consultancy
  const { isPending, isError, data, error } = useQuery(
    ["consultancy", slug], //Query key and dependency
    () =>
      axios({
        //Query function
        method: "get",
        url:
          WP_API_Settings.endpoint +
          "wp/v2/theme_consulting?slug=" +
          slug +
          "&_embed=true&acf_format=standard",
      })
  );

  useEffect(() => {
    if (data?.data) {
      setConsultancy(data.data[0]);
    }
  }, [data]);

  console.log(consultancy);

  return (
    <>
      <GlobalMeta />
      <InternalBanner
        featuredImage={
          consultancy?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
        }
        banner={consultancy?.acf.internal_banner}
      />
      <ConsultingMenu />
      <Specialists
        specialists={consultancy?.acf.specialists}
        description={consultancy?.acf.specialist_description}
        loading={!consultancy}
      />
      <Box id={"modules"} />
      {consultancy?.acf?.consultancy_tabs?.tabs &&
        consultancy.acf.consultancy_tabs.tabs.length > 1 && (
          <ConsultancyModules //new component
            consultancy_tabs={consultancy?.acf?.consultancy_tabs}
            loading={isInitialLoading}
          />
        )}
      <ConsultancyBullets
        bullets={consultancy?.acf.consultancy_bullets}
        loading={!consultancy}
      />
      {consultancy?.acf?.consultancy_tabs?.tabs &&
        consultancy.acf.consultancy_tabs.tabs.length === 1 && (
          <ConsultancyTabs
            tabs={consultancy?.acf.consultancy_tabs}
            loading={!consultancy}
          />
        )}

      <Accreditations
        accreditations={consultancy?.acf.accreditations}
        loading={!consultancy}
      />

      <RandomTestimonial
        testimonials={consultancy?.acf.testimonials}
        loading={!consultancy}
      />

      <PartnersCarousel loading={!consultancy} page={"consultancy"} />
      <ImageBGSection
        content={consultancy?.acf.image_background}
        loading={!consultancy}
      />
      <LatestInsights
        loading={!consultancy}
        consulting={true}
        pageData={consultancy}
      />
    </>
  );
}
